/**
 * OTP Route Type
 * Defines the context in which OTP verification is being used
 */
export enum OtpRouteType {
  SIGN_UP = 'sign-up',
  FORGOT_PASSWORD = 'forgot-password',
}
